module.exports = __webpack_public_path__ + "static/media/ic-outlet-black.d6c9e958.svg";